export default __webpack_public_path__ + "static/logzio-metricsandtracing-3fe701908ee481d023c2e737515ae858.png";